export default __webpack_public_path__ + "static/InterDisplay-Bold-4bc3d5c7c153ceaada2133f3a1d683fe.woff2";